import { useTranslation } from 'next-i18next'
import { Dispatch, Fragment, SetStateAction, useState } from 'react'
import ArrowLeftIcon from 'assets/icons/nucleo/18px_arrow-left.svg'
import XMarkIcon from 'assets/icons/nucleo/18px_xmark.svg'
import { Level2CategoryLink } from 'components/Layout/Header/DisciplineContent/DisciplineContent.style'
import { Level2CategoriesContainer } from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/MobileDisciplineContent.style'
import {
  Level1CategoriesButton,
  StyledChevronDown,
  StyledChevronUp
} from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/RaceTypeSelection/RaceTypeSelector.style'
import { NavigationHeader } from 'components/Layout/Header/DisciplineContent/NavigationHeader'
import { minWidthIcon } from 'components/Layout/Header/Header.style'
import { Drawer } from 'components/common/Drawer/Drawer'
import {
  BlackText,
  FlexContainer,
  FlexSpaceBetweenContainer,
  VerticallySelfCenteredDiv
} from 'components/common/common.style'
import { raceCategoriesLevel1, urlParser } from 'helpers/raceCategoryLevels'
import { recordKeys } from 'helpers/records'

interface RaceTypeSelectorProps {
  setIsSelectingRaceType: Dispatch<SetStateAction<boolean>>
  isVisible: boolean
}
export const RaceTypeSelector = ({
  setIsSelectingRaceType,
  isVisible
}: RaceTypeSelectorProps) => {
  const { t } = useTranslation('common')
  const { t: frenchT } = useTranslation('common', { lng: 'fr' })
  const [activeLevel1Category, setActiveLevel1Category] = useState<
    keyof typeof raceCategoriesLevel1 | undefined
  >(undefined)
  const level2Categories = activeLevel1Category
    ? raceCategoriesLevel1[activeLevel1Category].level2Categories
    : []

  return (
    <Drawer
      open={isVisible}
      onClose={() => setIsSelectingRaceType(false)}
      anchor="right"
      sx={{
        '& .MuiDrawer-paper': {
          width: '80%',
          borderTopLeftRadius: '8px',
          borderBottomLeftRadius: '8px'
        }
      }}
    >
      <FlexContainer style={{ flexDirection: 'column' }}>
        <NavigationHeader
          text={t('menu.raceType')}
          leftIcon={
            <ArrowLeftIcon
              css={minWidthIcon}
              onClick={() => setIsSelectingRaceType(false)}
            />
          }
          rightIcon={
            <XMarkIcon
              css={minWidthIcon}
              onClick={() => setIsSelectingRaceType(false)}
            />
          }
        />

        {recordKeys(raceCategoriesLevel1).map((type) => {
          const isSelected = type === activeLevel1Category
          return (
            <Fragment key={type}>
              <Level1CategoriesButton
                key={type}
                $isSelected={isSelected}
                onClick={() => {
                  if (activeLevel1Category === type)
                    setActiveLevel1Category(undefined)
                  else setActiveLevel1Category(type)
                }}
              >
                <FlexSpaceBetweenContainer style={{ height: '100%' }}>
                  <VerticallySelfCenteredDiv>
                    <BlackText semiBold noMargin>
                      {t(type)}
                    </BlackText>
                  </VerticallySelfCenteredDiv>
                  <VerticallySelfCenteredDiv>
                    {isSelected ? <StyledChevronUp /> : <StyledChevronDown />}
                  </VerticallySelfCenteredDiv>
                </FlexSpaceBetweenContainer>
              </Level1CategoriesButton>
              {isSelected && (
                <Level2CategoriesContainer>
                  <Level2CategoryLink
                    passHref
                    href={`/${urlParser(raceCategoriesLevel1[type].url)}`}
                  >
                    <BlackText semiBold noMargin>
                      <span>{t(`ALL_${type}`)} </span>
                    </BlackText>
                  </Level2CategoryLink>

                  {level2Categories.map((level2Category) => (
                    <Level2CategoryLink
                      key={level2Category}
                      passHref
                      href={`/${urlParser(frenchT(level2Category))}`}
                    >
                      <BlackText semiBold noMargin>
                        <span>{t(level2Category)}</span>
                      </BlackText>
                    </Level2CategoryLink>
                  ))}
                </Level2CategoriesContainer>
              )}
            </Fragment>
          )
        })}
      </FlexContainer>
    </Drawer>
  )
}
